<a class="skip-link" href="#main-content">Skip to content</a>
<app-site-header></app-site-header>

<main id="main-content">
  <router-outlet></router-outlet>
</main>

<app-site-footer></app-site-footer>
